export default "/images/vendor/lightbox2/src/prev.png?0edc57ccafb3ea81859786274edf7897";